import { Group, Text } from '@mantine/core';

interface Props {
  name: string | null | undefined;
  color?: string | null;
  size?: number;
}

/** Skupina se všude pozná barevným čtverečkem — barvy si zadává organizátor. */
export function GroupTag({ name, color, size = 9 }: Props) {
  if (!name) return <Text c="dimmed" fz="sm">—</Text>;
  return (
    <Group gap={6} wrap="nowrap" component="span" display="inline-flex">
      <span
        style={{
          width: size,
          height: size,
          borderRadius: 2,
          flex: `0 0 ${size}px`,
          background: color || 'var(--mantine-color-gray-5)',
          boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.12)',
        }}
      />
      <Text component="span" fz="sm" fw={550} style={{ whiteSpace: 'nowrap' }}>{name}</Text>
    </Group>
  );
}
